import { render, staticRenderFns } from "./editTask.vue?vue&type=template&id=9769b78c&scoped=true&"
import script from "./editTask.vue?vue&type=script&lang=js&"
export * from "./editTask.vue?vue&type=script&lang=js&"
import style0 from "./editTask.vue?vue&type=style&index=0&id=9769b78c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9769b78c",
  null
  
)

export default component.exports